
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M3.5 11.623v3.002c0 .483.373.875.834.875h8.333c.46 0 .833-.392.833-.875v-8.71a1 1 0 0 0-.293-.708L9.793 1.793a1 1 0 0 0-.707-.293H4.334c-.46 0-.834.392-.834.875v1.377M2.247 6h4.795M4.196 9h4.3m-1.883 3h3.58"}})])
          )
        }
      }
    